<template>
    <div>
        <div class="d-sm-block d-mb-block d-lg-none" v-if="isMobile">
            <div class="main-container-mobile pb-6" :style="bgStyle">
                <div class="logo-container">
                    <img class="logo-registration-mobile" src="@/assets/img/ararat-reg-logo-mobile.svg"
                        alt="logo-registration..." />
                </div>
                <div class="registration-body-container">
                    <!-- <div class="title-container-mobile">
                        <p class="text-title-mobile">Absolut haring!</p>
                    </div> -->
                    <div class="title-container-span-mobile">
                        <p class="text-title-span-mobile">Регистрируйтесь и получите SMS с фотографиями!</p>
                        <p class="text-title-span-mobile-1"> Отмечайте <br/> <a href="https://www.instagram.com/araratkazakhstan/" target="_blank">@araratkazakhstan</a></p>
                    </div>
                    <div v-if="isLoadingForm" class="form-loading">
                        <v-progress-circular indeterminate size="64" color="#482E24" />
                    </div>
                    <div v-else-if="formError" class="form-error">
                        <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                        <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                            попытку</button>
                    </div>
                    <div v-else class="form-main-mobile">
                        <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                            <!-- input text/email/etc -->
                            <div>
                                <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body-mobile"
                                    v-model="formData[question.id]" :placeholder="getPlaceholder(question)"
                                    @blur="markTouched(question)" @input="validateField(question)" />
                                <input v-else-if="question.type === 4" class="input-body-mobile"
                                    v-model="formData[question.id]" type="tel" v-mask="'+7(###) ###-##-##'"
                                    placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                    @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                <div class="error-message">
                                    <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                </div>
                            </div>
                            <!-- select -->
                            <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                :items="question.answers" item-text="name" item-value="id" dense outlined hide-details
                                :placeholder="getPlaceholder(question)" class="my-select mb-4 pt-1">
                                <template v-slot:selection="{ item }">
                                    <div class="select-input" style="white-space: normal; word-break: break-word;">
                                        {{ item.name }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                        <div class="btn-container mt-1">
                            <div v-for="question in filteredQuestions" :key="question.id + '-checkbox'"
                                class="checkbox-container">
                                <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                    :id="question.id" @change="markTouched(question)"
                                    @input="validateField(question)" />
                                <label class="checkbox-label" :for="question.id" style="color: var(--color-primary-span);">
                                    <!-- если это согласие на обработку персональных данных -->
                                    <template v-if="question.number === 7">
                                        Я даю согласие на
                                        <a style="color: var(--color-primary-dark); text-decoration: underline;"
                                            @click.stop.prevent="openPopup('offer')">
                                            сбор и обработку персональных данных
                                        </a>
                                    </template>

                                    <!-- для всех остальных чекбоксов -->
                                    <template v-else>
                                        {{ question.name }}
                                    </template>
                                </label>
                            </div>
                            <!-- <div class="checkbox-container" v-if="consentQuestion">
                                    <input class="checkbox" type="checkbox" :id="consentQuestion.id"
                                        v-model="answers[consentQuestion.id]"
                                        :name="consentQuestion.id"
                                        checked />
                                    <label :for="consentQuestion.id">Я даю согласие на <a
                                            style="color: white;text-decoration:underline;"
                                            @click="openPopup('offer')">сбор и обратботку
                                            персональных
                                            данных</a></label>confirmRegistration
                                </div> -->
                            <button @click="confirmRegistration" class="btn-form-submit-mobile mt-6 mb-6"
                                :disabled="isSendSms">{{ isSendSms ?
                                    "Отправка..." : "Зарегистрироваться" }}</button>
                        </div>
                    </div>
                </div>
                <div class="addition-height"></div>
            </div>
        </div>
        <div class="d-none d-lg-block d-xl-block d-xxl-block" v-else>
            <div class="main-container pb-10" :style="bgStyle">
                <div class="logo-container">
                    <img class="logo-registration" src="@/assets/img/ararat-reg-logo.png" alt="logo-registration..." />
                </div>
                <div class="registration-body-container">
                    <!-- <div class="title-container">
                        <p class="text-title">Ararat haring!</p>
                        <p class="text-title">Джемесона в Jameson Camp</p>
                    </div>  -->
                    <div class="title-container-span">
                        <p class="text-title-span">Регистрируйтесь и получите SMS <br/>с фотографиями!</p>
                        <p class="text-title-span-2">Отмечайте <a href="https://www.instagram.com/araratkazakhstan/" target="_blank">@araratkazakhstan</a></p>
                    </div>
                    <div v-if="isLoadingForm" class="form-loading">
                        <v-progress-circular indeterminate size="64" color="#482E24" />
                    </div>
                    <div v-else-if="formError" class="form-error">
                        <p class="form-error-text">Ошибка загрузки формы. Попробуйте позже.</p>
                        <button class="btn-form-submit mt-10 mb-10" @click="getFormFields">Повторить
                            попытку</button>
                    </div>
                    <div v-else class="form-main">
                        <div v-for="question in normalQuestions" :key="question.id" class="form-container">
                            <label>{{ question.name }}</label>

                            <!-- input text/email/etc -->
                            <div>
                                <input v-if="[1, 2, 7, 10].includes(question.type)" class="input-body"
                                    v-model="formData[question.id]" :placeholder="getPlaceholder(question)"
                                    @blur="markTouched(question)" @input="validateField(question)" />
                                <input v-else-if="question.type === 4" class="input-body"
                                    v-model="formData[question.id]" v-mask="'+7(###) ###-##-##'"
                                    placeholder="+7 (___) ___-__-__" @blur="markTouched(question)"
                                    @focus="onPhoneFocus(question)" @input="onPhoneInput(question)" />
                                <div class="error-message">
                                    <span v-show="errors[question.id]">{{ errors[question.id] }}</span>
                                </div>
                            </div>
                            <!-- select -->
                            <v-select v-if="[5, 9, 6].includes(question.type)" v-model="formData[question.id]"
                                :items="question.answers" item-text="name" item-value="id" dense outlined hide-details
                                :placeholder="getPlaceholder(question)" class="my-select mb-4">
                                <template v-slot:selection="{ item }">
                                    <div class="select-input" style="white-space: normal; word-break: break-word;">
                                        {{ item.name }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>
                    <div v-if="!formError" class="btn-container mt-6">
                        <div v-for="question in filteredQuestions" :key="question.id + '-checkbox'"
                            class="checkbox-container">
                            <div class="checkbox-content">
                                <input class="custom-checkbox" type="checkbox" v-model="formData[question.id]"
                                    :id="question.id" @change="markTouched(question)"
                                    @input="validateField(question)" />
                                <label class="checkbox-label" :for="question.id" style="color: var(--color-primary-span);">
                                    <!-- если это согласие на обработку персональных данных -->
                                    <template v-if="question.number === 7">
                                        Я даю согласие на
                                        <a style="color: var(--color-primary-dark); text-decoration: underline;"
                                            @click.stop.prevent="openPopup('offer')">
                                            сбор и обработку персональных данных
                                        </a>
                                    </template>

                                    <!-- для всех остальных чекбоксов -->
                                    <template v-else>
                                        {{ question.name }}
                                    </template>
                                </label>
                            </div>
                        </div>
                        <!-- <div class="checkbox-container" v-if="consentQuestion">
                                    <input class="checkbox" type="checkbox" :id="consentQuestion.id"
                                        v-model="answers[consentQuestion.id]"
                                        :name="consentQuestion.id"
                                        checked />
                                    <label :for="consentQuestion.id">Я даю согласие на <a
                                            style="color: white;text-decoration:underline;"
                                            @click="openPopup('offer')">сбор и обратботку
                                            персональных
                                            данных</a></label>
                                            confirmRegistration
                                </div> -->
                        <button @click="confirmRegistration" class="btn-form-submit mt-10 mb-10"
                            :disabled="isSendSms">{{
                                isSendSms ? "Отправка..." : "Зарегистрироваться" }}</button>

                    </div>
                </div>
            </div>
        </div>
        <otp :showPopup="showOtpPopup" :smsTimer="smsTimer" :errorSms="otpErrorSms" @resend="resendSms"
            @verifyCode="submitAnswersWithCode" @closePopup="showOtpPopup = false" :success="otpSuccess"
            :errorMessage="otpError" :loading="otpVerifying" />
        <!-- <transition name="popup">
            <div v-if="showPopup" class="popup-overlay" @click.self="closePopup">
                <div class="popup-container">

                    <button class="popup-close" @click="closePopup"><svg width="18" height="19" viewBox="0 0 18 19"
                            fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M0.494853 15.703C-0.144973 16.3298 -0.158031 17.4789 0.50791 18.1448C1.17385 18.8108 2.32293 18.7847 2.94969 18.1579L9.00845 12.0991L15.0672 18.1448C15.7201 18.7977 16.8431 18.8108 17.509 18.1318C18.1749 17.4658 18.1749 16.3429 17.5221 15.69L11.4764 9.64428L17.5221 3.58553C18.1749 2.93264 18.1749 1.80968 17.509 1.14374C16.8431 0.464742 15.7201 0.4778 15.0672 1.13068L9.00845 7.17638L2.94969 1.11763C2.32293 0.490858 1.17385 0.464742 0.50791 1.13068C-0.158031 1.79662 -0.144973 2.9457 0.494853 3.58553L6.55361 9.64428L0.494853 15.703Z"
                                fill="#F2E4B5" />
                        </svg></button>
                    <div class="popup-content">
                        <img src="@/assets/img/jameson-pop-up.svg" alt="Logo" class="popup-logo" />
                        <div class="text-container-popup">
                            <h2 class="popup-title">Ты участвуешь!</h2>
                            <p class="popup-text">Розыгрыш в 21:00 — не пропусти.</p>
                        </div>

                    </div>
                </div>
            </div>
        </transition> -->
        <ConfirmAge1 v-if="showConfirm" @confirmed="onConfirmed" />
        <transition name="popup">
            <div v-if="isPopupOpen" class="popup-overlay" @click.self="closePopup">
                <div class="popup-content">
                    <div class="popup-header">
                        <span class="header-text">{{ popupTexts[currentPopup].title }}</span>
                        <span class="popup-close-1" @click="closePopup"><svg width="21" height="21" viewBox="0 0 40 40"
                                fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M1.07373 33.4784C-0.348236 34.8712 -0.377256 37.4247 1.10275 38.9046C2.58275 40.3845 5.13648 40.3264 6.52942 38.9336L19.9945 25.4697L33.4597 38.9046C34.9106 40.3555 37.4063 40.3845 38.8863 38.8756C40.3663 37.3957 40.3663 34.9003 38.9154 33.4494L25.4793 20.0145L38.9154 6.5506C40.3663 5.09975 40.3663 2.60428 38.8863 1.12441C37.4063 -0.384476 34.9106 -0.355459 33.4597 1.09539L19.9945 14.5303L6.52942 1.06638C5.13648 -0.326442 2.58275 -0.384476 1.10275 1.09539C-0.377256 2.57526 -0.348236 5.12876 1.07373 6.5506L14.5388 20.0145L1.07373 33.4784Z"
                                    fill="#FFFFFF" />
                            </svg></span>
                    </div>
                    <div class="popup-text-1" v-html="popupTexts[currentPopup].content"></div>
                </div>
            </div>
        </transition>
        <v-snackbar v-model="snackbar" timeout="3000" class="btn-contaiener">
            {{ message }}
            <template v-slot:action="{ attrs }">
                <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                    Закрыть
                </div>
            </template>
        </v-snackbar>
        <div></div>
    </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import Otp from '@/components/otp.vue';
import ConfirmAge1 from "@/components/age-confirm.vue";
export default {

    directives: { mask },
    name: "Registration",
    components: {
        Otp,
        ConfirmAge1
    },
    data() {
        return {
            otpErrorSms: false,
            showConfirm: true,
            isMobile: window.innerWidth < 1264,
            screenWidth: window.innerWidth,
            phone: '',
            items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
            isSendSms: false,
            checkbox: false,
            email: '',
            name: '',
            city: '',
            snackbar: false,
            message: "",
            otp: '',
            expectedOtp: '1111',
            loading: false,
            smsTimer: 60, // 60 секунд
            smsTimerInterval: null,
            isPopupOpen: false,
            currentPopup: null,
            showPopup: false,
            formSchema: null,
            otpSuccess: false,
            otpVerifying: false,
            showOtpPopup: false,
            isLoadingForm: true,
            formError: false,
            otpError: "",
            formData: {},
            errors: {},
            touched: {},
            popupTexts: {
                offer: {
                    title: "СОГЛАСИЕ НА СБОР И ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ (для клиентов и потенциальных клиентов)",
                    content: `Я подтверждаю, что достиг возраста 21 года и более и даю <b>ТОО «Перно Рикар
                Казахстан», (БИН 050840001045),</b> а также их работникам и третьим лицам-соисполнителям по
                заключенным между ними договорам, <b>свое согласие</b> на сбор, обработку,
                распространение и трансграничную передачу (без дополнительных уведомлений)
                моих персональных данных, относящихся исключительно к перечисленным ниже
                категориям персональных данных:
                 1) ФИО
                 2) Город проживания
                 3) Мобильный телефон
                 4) E-mail
                <b>Согласованная цель сбора и обработки персональных данных</b> – пополнение CRM
                базы посредством предоставления персональных данных любыми средствами связи
                для участия в активностях, проводимых в отношении товарных знаков продукции
                ТОО «Перно Рикар Казахстан».
                Я даю согласие на использование персональных данных исключительно в
                вышеуказанных целях, а также на обработку персональных данных и их
                трансграничную передачу на всех электронных носителях, используемых для
                вышеуказанной цели.
                Настоящее согласие предоставляется мной на осуществление действий в отношении
                моих персональных данных, которые необходимы для достижения указанных выше
                целей, включая (без ограничения) сбор, систематизацию, накопление, хранение,
                уточнение (обновление, изменение), использование, передачу третьим лицам для
                осуществления действий по обмену информацией, обезличивание, блокирование
                персональных данных, трансграничную передачу персональных данных на территорию любого государства, в том числе не обеспечивающего защиту персональных данных, распространение моих персональных данных в общедоступных источниках,
                а также осуществление любых иных действий,
                предусмотренных действующим законодательством Республики Казахстан.
                Я предоставляю согласие на контактирование со мной для вышеуказанных целей путем осуществления разговора, телефонных звонков, направления мне уведомлений с использованием почты, телефона (также SMS), социальных сетей и/или мессенджеров, вебсайтов, электронной почты, электронных информационных ресурсов и иных информационных систем и мобильных приложений. 
                Я проинформирован, что вышеуказанные компании гарантируют обработку моих
                персональных данных в соответствии с действующим законодательством Республики
                Казахстан как неавтоматизированным, так и автоматизированным способами.
                Данное согласие действует в течение срока хранения информации в вышеуказанных
                целях.
                Данное согласие может быть отозвано в любой момент по моему письменному заявлению, отправленному в адрес Компании по ее юридическому адресу, зарегистрированному на дату отправки заявления или посредством направления электронного сообщения на электронную почту Компании: promo.kz@pernod-ricard.com. В случае отзыва настоящего согласия все мои Персональные данные подлежат уничтожению из базы данных Компании. 
Я подтверждаю, что для включения моих персональных данных в базу данных, в том числе партнеров указанных компаний, передачи, распространения, дополнения и прочей обработки моих персональных данных указанными компаниями с вышеупомянутой целью не требуется дополнительного уведомления меня о совершении данных действий. 

Я подтверждаю, что, давая настоящее согласие, я действую по собственной воле, в своих интересах и полностью осознаю суть и цели подписываемого документа. `,
                },
            },
        };
    },
    computed: {
        bgStyle() {
            const isMobile = this.isMobile;
            return {
                backgroundImage: `url(${require(isMobile
                    ? '@/assets/img/ararat-reg-bg.jpg'
                    : '@/assets/img/ararat-reg-bg.jpg')})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center top',
                width: '100%',
                minHeight: '100vh'
            };
        },
        ...mapGetters(['getUserAge']),
        filteredQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type === 11 || q.type === 12));
        },
        normalQuestions() {
            if (!this.formSchema?.questions) return [];
            return this.formSchema.questions.filter(q => (q.type !== 11 && q.type !== 3 && q.type !== 12));
        }
    },
    created() {
        if (localStorage.getItem("userAge") !== null) {
            this.showConfirm = false
        }
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        console.log('Возраст пользователя:', this.getUserAge);
        this.getFormFields();
        // Здесь можно использовать this.getUserAge.day, .month, .year
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        formData: {
            deep: true,
            handler(val) {
                for (let [id, value] of Object.entries(val)) {
                    this.validateField(id, value);
                }
            }
        },
        getUserAge(newVal) {
            if (!newVal || !this.formSchema) return;

            const birthQuestion = this.formSchema.questions.find(q => q.type === 3);
            if (birthQuestion) {
                this.$set(this.formData, birthQuestion.id, newVal);
                console.log("NEW DATA");
            }
        }
    },
    methods: {
        handleResize() {
            this.isMobile = window.innerWidth < 1264;
            this.screenWidth = window.innerWidth;
        },
        onConfirmed() {
            this.showConfirm = false
            console.log("Компонент закрыт")
            // localStorage.setItem("ageConfirmed", "1")
        },
        logCity() {
            console.log(this.city);
        },
        logNumber() {
            console.log(this.phone);
        },
        async confirmRegistration() {
            this.otpError = "";
            if (!this.formSchema) return;
            console.log(this.formData);
            const hasEmptyField = Object.keys(this.formData).some(key => {
                const value = this.formData[key];
                console.log(this.formData);
                const type = this.formSchema.questions.find(q => q.id === this.formData[key])?.type; // допустим, вопросы в массиве

                if (type === 11 || type === 12) {
                    // чекбокс — false = ошибка
                    return value === false;
                }

                // для остальных — пустые значения
                return value === null || value === undefined || value === '';
                // return value === null || value === undefined || value === '' || value === false;
            });

            // Проверка: есть ли ошибки валидации
            const hasErrors = Object.values(this.errors).some(error => error && error.length > 0);
            console.log("Erors", this.errors);
            if (hasEmptyField || hasErrors) {
                this.snackbar = true;
                this.message = hasErrors
                    ? 'Исправьте ошибки в форме перед отправкой'
                    : 'Пожалуйста, заполните все поля';
                return;
            }
            try {
                console.log(this.formData);
                this.isSendSms = true;
                    const isSent = await this.sendVerificationCode();
                    
                    // Открываем попап только если СМС реально ушло и нет 409 ошибки
                    if (isSent && !this.otpErrorSms) { 
                        this.otpError = "";
                        this.otpSuccess = false;
                        this.showOtpPopup = true;
                        this.startSmsTimer();
                    }
            } catch {
                this.snackbar = true;
                this.message = 'Ошибка при отправке кода. Попробуйте снова.';
            }
            finally {
                this.isSendSms = false;
            }
        },
        closePopup() {
            this.showPopup = false;
            this.isPopupOpen = false;
            // Очистка полей
            this.phone = '';
            this.email = '';
            this.name = '';
            this.city = '';
            this.checkbox = false;
        },
        validateField(question) {
            const value = this.formData[question.id];
            let error = null;

            // Проверка только для текстовых полей (например id 1,2,7,4)
            if ([1, 2, 4, 7].includes(question.type)) {
                if (!value || value.trim() === "") {
                    error = "Поле обязательно";
                }
            }
            if ([11].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if ([12].includes(question.type)) {
                if (!value && this.touched[question.id]) {
                    error = "Вы должны принять условия.";
                }
            }
            if (error === null) {
                if ([1].includes(question.type)) {
                    // Имя только буквы
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректное имя.";
                    }
                }

                if ([2].includes(question.type)) {
                    // Фамилия только буквы
                    if (!/^[А-Яа-яA-Za-z\s]+$/.test(value)) {
                        error = "Введите корректную фамилию.";
                    }
                }

                if ([7].includes(question.type)) {
                    // Email
                    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
                        error = "Введите корректный email.";
                    }
                }

                if ([4].includes(question.type)) {
                    // Телефон
                    if (!/^\+7\(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(value)) {
                        error = "Введите корректный номер телефона.";
                    }
                }
            }

            this.$set(this.errors, question.id, error);
        },
        markTouched(question) {
            this.$set(this.touched, question.id, true);
            this.validateField(question);
        },
        getPlaceholder(question) {
            switch (question.type) {
                case 5:
                    return "Город";
                case 9:
                    return "Продукт";
                case 10:
                    return "Введите логин ";
                default:
                    return question.name;
            }
        },
        getFormFields() {
            this.isLoadingForm = true;
            this.formError = false;
            this.$http.get('/api/survey', {
                params: {
                    campaignId: "2976cc2c-7e86-f111-b801-00155d79212a"
                }
            })
                .then(res => {
                    this.formSchema = res.data;
                    // Инициализируем значения
                    res.data.questions.forEach(q => {
                        if (q.type === 3) {
                            this.$set(this.formData, q.id, this.getUserAge);
                        } else {
                            this.$set(this.formData, q.id, "");
                        }
                    });
                })
                .catch(err => {
                    this.formError = true;
                    console.error("Ошибка загрузки формы", err);
                })
                .finally(() => {
                    this.isLoadingForm = false;
                });
        },
        openPopup(type) {
            this.currentPopup = type
            this.isPopupOpen = true
        },
        async submitAnswersWithCode(code) {
            this.otpVerifying = true;
            this.otpError = "";
            this.otpSuccess = false;
            try {
                const payload = {
                    surveyId: this.formSchema.id,
                    campaignId: "2976cc2c-7e86-f111-b801-00155d79212a",
                    verificationCode: code,
                    answers: Object.entries(this.formData).map(([key, value]) => {
                        let answer = String(value);

                        if (/^\+7[\d\s()-]{10,}$/.test(answer)) {
                            answer = answer.replace(/[^\d+]/g, '');
                        }

                        return {
                            surveyQuestionId: key,
                            answer
                        };
                    })
                };

                await this.$http.post('/api/AnswerSet', payload);
                this.otpSuccess = true;
                this.formData = {};
                // this.showOtpPopup = false; // закрыть попап
            } catch (error) {
                console.error(error);
                const msg = error?.response?.data?.message || "Код введён неверно";
                this.otpError = msg;
            } finally {
                this.otpVerifying = false;
            }
        },
        startSmsTimer() {
            this.smsTimer = 60;
            if (this.smsTimerInterval) clearInterval(this.smsTimerInterval);
            this.smsTimerInterval = setInterval(() => {
                if (this.smsTimer > 0) {
                    this.smsTimer--;
                } else {
                    clearInterval(this.smsTimerInterval);
                    this.smsTimerInterval = null;
                    // Здесь можно вызвать метод компонента otp через $refs, если нужно
                }
            }, 1000);
        },
        async sendVerificationCode() {

            const phoneQuestion = this.formSchema.questions.find(q => q.type === 4);
            if (!phoneQuestion) return;

            const phoneAnswerRaw = this.formData[phoneQuestion.id];
            const phoneAnswer = phoneAnswerRaw.replace(/[^\d+]/g, "");
            try {
                this.isSendSms = true; // Блокируем кнопку, пока идет проверка капчи

                await this.$recaptchaLoaded();
                const recaptchaToken = await this.$recaptcha('send_sms'); 

                // 2. Готовим DTO, добавив туда токен капчи
                const answerDto = {
                    campaignId: "2976cc2c-7e86-f111-b801-00155d79212a",
                    surveyAnswer: {
                        surveyQuestionId: phoneQuestion.id,
                        answer: phoneAnswer
                    },
                    recaptchaToken: recaptchaToken // <--- Отправляем токен на бэкенд
                };
                console.log("Token:", recaptchaToken);
                console.log(answerDto);
                // 3. Отправляем запрос на наш API
                await this.$http.post("/api/Verification/SendCode", answerDto);
                console.log("Код отправлен!");
                this.otpErrorSms = false;
                return true;

            } catch (err) {
                console.error("Ошибка при отправке кода:", err);
                if (err?.response?.status === 409) {
                    // пользователь уже зарегистрирован
                    this.otpErrorSms = true;
                    this.showOtpPopup = true;
                    this.otpSuccess = false;
                    return false;
                }
                if (err?.response?.status === 403) {
                    // Бэкенд отбил запрос из-за низкого score капчи
                    this.snackbar = true;
                    this.message = 'Подозрение на бота. Попробуйте перезагрузить страницу.';
                    return false;
                }
            } finally {
                this.isSendSms = false;
            }
        },
        async resendSms() {
            // можно просто вызвать sendVerificationCode ещё раз
            this.startSmsTimer();
            await this.sendVerificationCode();
        },
        onPhoneFocus(question) {
            if (!this.formData[question.id]) {
                this.$set(this.formData, question.id, '+7');
            }
        },
        onPhoneInput(question) {
            const val = this.formData[question.id] || '';
            if (!val.startsWith('+7')) {
                this.formData[question.id] = '+7' + val.replace(/\D/g, '').slice(1);
            }
            this.validateField(question);
        },
    }
};
</script>

<style scoped>
/* --------------------------------------------MAIN-STYLE-DESKTOP */
.main-container {
    width: 100%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
}

.main-container-mobile {
    width: 100%;
    min-height: 100vh;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center top;
    padding-bottom: 30px;
}

.addition-height {
    height: 30px;
}

.logo-container {
    margin: auto;
    text-align: center;
}

.logo-registration {
    width: 334px;
    height: 217.34px;
    -o-object-fit: contain;
    object-fit: contain;
    margin-top: 4.35185185185vh;
    margin-bottom: 2.92592592593vh;
}

.registration-body-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    /* width: 53.85vw; */
    max-width: 1033px;
    /* min-width: 320px; */
    height: 100%;
    /* max-height: 713px; */
    /* min-height: 400px; */
    background: #FFFFFF;
    /* background-image: url('../assets/img/absolut-reg-form-bg.jpg'); */
    background-size: cover;
    background-position: top;
    margin: auto;
}

.title-container {
    width: 777px;
    margin: auto;
    padding-top: 3.48vh;
}

.title-container-span {
    margin-top: 23px;
    margin-bottom: 43px;
}

.text-title {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-xxl);
    line-height: 121%;
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 0;
}

.text-title-span {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-xl);
    line-height: 121%;
    text-align: center;
    color: var(--color-primary-span);
    margin-bottom: 0;
}
.text-title-span-2 {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    line-height: 121%;
    text-align: center;
    color: var(--color-primary-dark);
    margin-bottom: 0;
    margin-top: 13px;
}

.text-title-span-2 a {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    line-height: 121%;
    text-align: center;
    color: var(--color-primary-dark);
    margin-bottom: 0;
    cursor: pointer;
    text-decoration: underline;
    /* Добавляем плавный переход для изменения цвета */
    transition: color 0.3s ease-in-out; 
}

/* Добавляем стили для наведения мыши */
.text-title-span a:hover {
    color: #ffffff; /* Меняем цвет текста на белый */
}

.form-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 30px;
}

.form-error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.form-error-text {
    font-weight: 400;
    font-size: var(--font-size-xs);
    color: var(--color-error-dark);
    margin-bottom: 0px;
    font-family: var(--font-family);
    text-align: center;
}

.error-message {
    color: red;
    font-weight: 300;
    font-size: var(--font-size-xxs);
    font-family: var(--font-family);
    min-height: 18px;
}

/* ------------------------------------Form-input-container */
.form-main {
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    /* text-align: left; */
    /* margin: auto; */
    width: 100%;
    /* max-width: 603px; */
    max-width: 583px;
    margin: 0 auto;
    gap: 15px;
}

.form-container label {
    color: var(--color-primary-span);
    font-size: var(--font-size-md);
    font-weight: 400;
    margin-right: 30px;
    text-align: left;
    font-family: var(--font-family);
}

.form-container {
    display: flex;
    align-items: baseline;
    /* Центрирование по вертикали */
    justify-content: flex-end;
    /* Разделение текста и поля ввода */
    width: 100%;
    /* Растягиваем контейнер */
}

.input-body {
    border: 1px solid var(--color-primary-dark);
    border-radius: 10px;
    padding: 15px 14px;
    width: 461px;
    height: 50px;
    font-size: var(--font-size-md);
    color: var(--color-primary-span);
    font-family: var(--font-family);
    /* margin-left: auto; */
    /* Выравнивание поля ввода вправо */
}

.input-body::placeholder {
    color: var(--color-primary-span);
    font-size: var(--font-size-md);
    opacity: 1;
}

input:focus {
    outline: 1px solid #1976d2;
    box-shadow: 0 0 5px #1976d2;
}

.btn-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.checkbox-container {
    display: flex;
    align-items: center;
    text-align: left;
    justify-content: center;
}

.custom-checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

/* стили для label */
.checkbox-label {
    /* display: flex;
  align-items: flex-start; */
    cursor: pointer;
    font-size: var(--font-size-md);
    line-height: 1.3;
    font-family: var(--font-family);
    /* твой кастомный шрифт */
    position: relative;
    padding-left: 24px;
    /* отступ под квадратик */
}

/* кастомный квадратик */
.checkbox-label::before {
    content: "";
    position: absolute;
    left: -8px;
    top: 2px;
    width: 20px;
    height: 20px;
    border: 1px solid var(--color-primary-border-checkbox);
    border-radius: 2px;
    /* убери, если нужен квадрат без скруглений */
    background-color: transparent;
}

.checkbox-label::after {
    content: "";
    position: absolute;
    left: 0px;
    top: 5px;
    width: 6px;
    height: 10px;
    border: solid transparent;
    /* по умолчанию невидимая */
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    transition: border-color 0.2s ease;
}

/* при checked — черный фон и белая галочка */
.custom-checkbox:checked+.checkbox-label::before {
    background-color: var(--color-primary-dark);
}

.custom-checkbox:checked+.checkbox-label::after {
    border-color: #FFFFFF;
    /* галочка белая */
}

.btn-form-submit,
.btn-form-submit-mobile {
    border-radius: 10px;
    padding: 11px 42px;
    height: 59px;
    color: var(--color-white-1);
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    background: var(--color-primary-light);
    cursor: pointer;
    /* box-shadow: 0 4px 0 #04581d; */
    /* легкая тень для объёма */

    /* медленный возврат */
    transition: all 0.4s ease;
}

/* При наведении */
.btn-form-submit:hover,
.btn-form-submit-mobile:hover {
    background: var(--color-primary-light);
    /* лёгкое затемнение белого */
    transform: translateY(-2px);
    box-shadow: 0 6px 0 #9c4f1b;

    /* ускоренный вход */
    transition: all 0.15s ease-out;
}

/* При нажатии */
.btn-form-submit:active,
.btn-form-submit-mobile:active {
    background: var(--color-primary-dark);
    /* чуть темнее для нажатия */
    transform: translateY(2px);
    box-shadow: 0 2px 0 #9e9e9e;
    transition: all 0.1s ease-in;
}

/* ------------------------------------------V-deep styles desktop */

::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    padding: 5px 0 5px 0;
    color: var(--color-primary-span);
    /* font-size: 18px; */
    font-family: var(--font-family);
}

::v-deep .v-select input::placeholder {
    color: var(--color-primary-span) !important;
    font-weight: 400;
    font-size: var(--font-size-md);
}

::v-deep .v-list-item--dense .v-list-item__title {
    font-size: var(--font-size-lg) !important;

}

.main-container ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-primary-dark) !important;
    border-radius: 6.64px;
}

.main-container ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: var(--font-size-md);
}

.main-container ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    width: 461px;
}

.main-container ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: 18px;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;

}

/* -----------------------------------------Pop-up-styles for text */
.popup-header {
    display: flex;
}

.popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.popup-content {
    background-color: var(--color-primary-light);
    background-size: cover;
    background-position: center;
    padding: 20px;
    width: 100%;
    max-width: 1150px;
    border-radius: 10px;
    /* max-height: 897px; */
    height: 100%;
    max-height: 80vh;
    /* ограничение всей области */
    display: flex;
    flex-direction: column;
    /* чтобы текст занимал всё доступное место */
    /* ограничение высоты */
    /* overflow-y: auto; */
    /* прокрутка */
}

.popup-text-1 {
    font-family: var(--font-family-medium);
    font-weight: 400;
    font-size: var(--font-size-lg);
    color: var(--color-white-1);
    line-height: 1.6;
    white-space: pre-line;
    padding: 0 15px;
    overflow-y: auto;
    /* скролл только текста */
    flex: 1;
}

.popup-text-1::-webkit-scrollbar {
    width: 8px;
    /* толщина */
}

/* Ползунок */
.popup-text-1::-webkit-scrollbar-thumb {
    background-color: var(--color-white-1);
    /* цвет (как на картинке) */
    border-radius: 10px;
    /* закругления */
}

/* Фон скроллбара */
.popup-text-1::-webkit-scrollbar-track {
    background: transparent;
    /* прозрачный трек */
}

.popup-close {
    margin-top: 10px;
    align-self: flex-end;
}

.popup-header {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header-text {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    text-transform: uppercase;
    color: var(--color-white-1);
}

.popup-close-1 {
    cursor: pointer;
}

/* =------------------------------SNackbar-styles */
.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: var(--font-family-medium);
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;
}

/* --------------------------------Анимации для странницы */
@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

@keyframes fadeOut {
    from {
        opacity: 1;
    }

    to {
        opacity: 0;
    }
}

@keyframes slideIn {
    from {
        transform: translateY(-20px);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes slideOut {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(-20px);
        opacity: 0;
    }
}

/* ------------------------------------Transition стили */
.popup-enter-active,
.popup-leave-active {
    animation: fadeIn 0.3s ease-in-out, slideIn 0.3s ease-in-out;
}

.popup-leave-active {
    animation: fadeOut 0.3s ease-in-out, slideOut 0.3s ease-in-out;
}

/* -----------------------------------------MOBILE styles */
.logo-registration-mobile {
    width: 185px;
    height: 145px;
    -o-object-fit: contain;
    object-fit: contain;
    margin-top: 1.35vh;
    margin-bottom: 1.92592592593vh;
}

.title-container-mobile {
    /* width: 777px;
    margin: auto; */
    margin: 0 20px;
    padding-top: 3.48vh;
}

.text-title-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
    margin-bottom: 0;
    line-height: 125%;
    word-wrap: break-word;
}

.title-container-span-mobile {
    margin-top: 10px;
    /* margin-bottom: 25px; */
}

.text-title-span-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    text-align: center;
    color: var(--color-primary-span);
    max-width: 500px;
    margin-bottom: 0;
}
.text-title-span-mobile-1 {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    text-align: center;
    color: var(--color-primary-dark);
    padding: 0 5px;
    max-width: 500px;
    margin-top: 13px;
}
.text-title-span-mobile-1 a{
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-md);
    text-align: center;
    color: var(--color-primary-dark);
    max-width: 500px;
    cursor: pointer;
    text-decoration: underline;
    /* Добавляем плавный переход для изменения цвета */
    transition: color 0.3s ease-in-out; 
}

/* Добавляем стили для наведения мыши */
.text-title-span-mobile a:hover {
    color: #ffffff; /* Меняем цвет текста на белый */
}



.text-title-mobile {
    font-family: var(--font-family-bold);
    font-weight: 700;
    font-size: var(--font-size-lg);
    text-transform: uppercase;
    text-align: center;
    color: var(--color-primary);
}


.form-main-mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    max-width: 666px;
}

.input-body-mobile {
    border: 1px solid var(--color-primary-dark);
    border-radius: 10px;
    padding: 15px 14px;
    min-width: 321px;
    width: 100%;
    height: 50px;
    font-size: var(--font-size-sm);
    color: var(--color-primary-span);
    font-family: var(--font-family);
}

.input-body-mobile::placeholder {
    color: var(--color-primary-span);
    /* Задайте нужный цвет */
    font-size: var(--font-size-sm);
    /* При необходимости измените размер шрифта */
    /* Добавьте стиль, например, курсив */
    opacity: 1;
    /* Убедитесь, что текст полностью видим */
}

/* ------------------------------------------V-deep styles mobile */

.main-container-mobile ::v-deep .v-select input::placeholder {
    font-size: var(--font-size-sm) !important;
    color: var(--color-primary-span) !important;
    /* нужный вам размер */
}

.main-container-mobile ::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input::placeholder {
    font-size: var(--font-size-sm) !important;
    font-family: var(--font-family);
    color: var(--color-primary-span) !important;
    font-weight: 400 !important;
}

.main-container-mobile ::v-deep .v-select input::placeholder {
    white-space: normal !important;
    word-break: break-word;
}

.main-container-mobile ::v-deep .v-select.v-text-field:not(.v-text-field--single-line) input {
    margin-top: 0;
    /* text-align: center; */
}

.main-container-mobile ::v-deep .v-text-field--outlined.v-input--dense.v-text-field--outlined>.v-input__control>.v-input__slot {
    min-height: 50px !important;
}

.main-container-mobile ::v-deep .v-select input::placeholder {
    font-size: var(--font-size-xxs) !important;
    /* нужный вам размер */
}

.main-container-mobile ::v-deep .theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset {
    color: var(--color-primary-dark) !important;
    border-radius: 6.64px;
}

.main-container-mobile ::v-deep .v-select.v-input--dense .v-select__selection--comma {
    margin: 0;
    font-size: var(--font-size-lg);
}

.main-container-mobile ::v-deep .v-input__slot {
    align-items: center;
    display: flex;
    margin-bottom: 8px;
    min-height: inherit;
    position: relative;
    transition: .3s cubic-bezier(.25, .8, .5, 1);
    transition-property: height, min-height;
    width: 461px;
}

.main-container-mobile ::v-deep .v-input {
    align-items: flex-start;
    display: flex;
    flex: none;
    font-size: var(--font-size-xs);
    letter-spacing: normal;
    max-width: 321px;
    text-align: left;
    height: 50px;
}

.main-container-mobile ::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
    color: var(--color-primary-span);
    font-size: var(--font-size-sm);
    font-family: var(--font-family);
}

.main-container-mobile ::v-deep .v-select input::placeholder {
    color: var(--color-primary-span) !important;
    font-weight: 400;
    font-size: var(--font-size-sm);

}

.main-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    padding: 0 12px;
    min-width: 321px !important;
    width: 100% !important;
}

.main-container-mobile ::v-deep .v-list-item--dense .v-list-item__title {
    font-size: var(--font-size-sm) !important;

}

.main-container-mobile ::v-deep .v-select__selections {
    display: flex;
    /* оставляем flex */
    align-items: center;
    /* выравнивание по центру */
    max-width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    /* ... в конце */
}

.main-container-mobile ::v-deep .v-select__selections span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
}

.main-container-mobile ::v-deep .v-select input::placeholder {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    display: block;
    width: 100%;
}

.main-container-mobile ::v-deep .v-select input {
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    width: 100% !important;
    display: block;
}


@media screen and (max-width: 1260px) {
    .checkbox-label {
        font-size: 15px;
    }

    /* кастомный квадратик */
    .checkbox-label::before {
        left: 0px;
        width: 15px;
        height: 15px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 3px;
    }

    .third-container {
        padding: 35px 0 0;
    }

    .title-container {
        padding-bottom: 39px;
    }

    .form-container {
        justify-content: center;
    }

    .checkbox-container label {
        color: black;
        text-align: left;
        font-size: 15px;
        font-weight: 400;
    }

    .btn-container {
        padding: 0 20px;
    }

    .header-text {
        font-family: var(--font-family-bold);
        font-weight: 700;
        font-size: var(--font-size-xs);
        text-transform: uppercase;
        color: var(--color-white-1);
    }

    /* Текст внутри */
    .popup-text-1 {
        font-family: var(--font-family-medium);
        font-weight: 400;
        font-size: var(--font-size-xs);
        color: var(--color-white-1);
        line-height: 1.6;
        white-space: pre-line;
        padding: 0;
        overflow-y: auto;
        /* скролл только текста */
        flex: 1;
    }

    .popup-close-1 {
        font-size: var(--font-size-xs);
    }

    .logo-registration {
        margin-top: 3.35vh;
        margin-bottom: 2.92592592593vh;
    }
}

@media screen and (max-width: 1050px) {
    .registration-body-container {
        margin: 0 20px;
    }

    .logo-registration {
        margin-top: 3.35vh;
        margin-bottom: 2.92592592593vh;
    }
}

@media screen and (max-width: 566px) {
    .checkbox-label::before {
        margin-top: 10px;
    }

    .checkbox-label::after {
        left: 5px;
        top: 13px;
    }

    .third-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        max-width: 321px !important;
        min-width: 100% !important;
    }
}

@media screen and (max-width: 376px) {
    .additional {
        padding: 30px 20px 0px 30px;
    }

    .error-message {
        font-size: var(--font-size-xxxs);
    }

    .input-body-mobile {
        max-width: 228px !important;
        min-width: 100% !important;
    }

    .addition-height {
        height: 50px;
    }

    .main-container-mobile ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
        max-width: 228px !important;
        min-width: 100% !important;
    }

}
</style>